module.exports = require('./lib/ua-device.js');